import { type Plan, type Transaction } from "../models/payment"

export function toPaymentStatusString(status: Transaction["status"]): string {
	switch (status) {
		case "success":
			return "Succeeded"
		case "pending":
			return "Pending"
		case "failed":
			return "Failed"
	}
}

export function getPlansAnnualDiscount(plans: Plan[]): number {
	return Math.max(...plans.flatMap(x => (x.price !== null ? 1 - x.price.year / (x.price.month * 12) : 0)))
}
